export const API_UPDATE_STATUS = {
    SUCCESS: 'success',
    FAILED: 'failed',
    PROCESSING: 'processing',
};
